import Emitter from '../Util/Emitter';
import Constants from '../Util/Constants';
import Log from '../../../npawPlugin/src/common/log';
import { BalancerTag } from '../../../npawPlugin/src/common/Constants';
/**
 * @class
 * @description Communication class that uses a websocket,
 * it has events for the different expected received messages and the method send
 * @extends Emitter
 * @exports WsCommunication
 */
export default class WsCommunication extends Emitter {
    static appendQueryParams(url, params) {
        const entries = Object.entries(params).filter(([, value]) => typeof value === 'string' && value.trim().length > 0);
        if (entries.length === 0) {
            return url;
        }
        try {
            const parsedUrl = new URL(url);
            entries.forEach(([key, value]) => {
                parsedUrl.searchParams.set(key, value);
            });
            return parsedUrl.toString();
        }
        catch (_a) {
            const query = entries
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}${query}`;
        }
    }
    /**
     * @constructs WsCommunication
     * @param {string} host Host URL
     * @public
     */
    constructor(config) {
        super();
        this._config = config;
    }
    /**
     * Opens the websocket connection
     * @returns {WsCommunication} this
     * @public
     */
    start() {
        if (this._ws) {
            this._ws.onclose = null;
            this._ws.onmessage = null;
            this._ws.onerror = null;
            this._ws.onopen = null;
            this._ws.close();
        }
        if ('undefined' !== typeof WebSocket) {
            const trackUrl = WsCommunication.appendQueryParams(this._config.tracker, {
                accountCode: this._config.accountCode,
                config: this._config.configName,
                'npaw-peer-group': this._config.swarmGroup
            });
            this._ws = new WebSocket(trackUrl);
            this._ws.onclose = () => {
                this.close();
            };
            this._ws.onmessage = (e) => {
                try {
                    this.emit(Constants.WSCommEvents.Data, JSON.parse(e.data));
                }
                catch (err) {
                    Log.warn(BalancerTag, err);
                }
            };
            this._ws.onerror = (e) => {
                this.emit(Constants.WSCommEvents.Error, e);
            };
            this._ws.onopen = (e) => {
                this.emit(Constants.WSCommEvents.Connected, e);
            };
        }
        return this;
    }
    /**
     * Sends the message using the socket
     * @param {trackerMessage} message Message object to be sent as a message by the websocket
     * @public
     */
    send(message = {}) {
        var _a;
        ((_a = this._ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 ? this._ws.send(JSON.stringify(message)) : null;
    }
    /**
     * Function to detect if the websocket has an active connection
     * @returns {boolean} if websocket is connected or not
     * @public
     */
    isConnected() {
        var _a;
        return ((_a = this._ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 || false;
    }
    /**
     * Callback and function for closed websocket connection
     * Removes the listeners
     * @public
     */
    close() {
        if (this._ws) {
            this._ws.onclose = null;
            this._ws.onmessage = null;
            this._ws.onerror = null;
            this._ws.onopen = null;
            this._ws.close();
            this.emit(Constants.WSCommEvents.Closed, this);
        }
    }
}
